import { TableSearchPipe } from './table-search.pipe';

export const SharedPipes = [
  TableSearchPipe
]

export {
  TableSearchPipe,
}

